const useImportActions = () => {
  const updateActionIds = (action, connectedOrPreviousActions) => {
    const hasEntityMetaId = !!action.actionSet.entityMetaId

    return connectedOrPreviousActions
      .filter((copa) => {
        const sameAnalysisOrActionName = (action.actionSet.analysisName !== null)
          ? copa.actionSet.analysisName === action.actionSet.analysisName
          : copa.actionSet.actionName === action.actionSet.actionName

        if (hasEntityMetaId) {
          return sameAnalysisOrActionName
            && (copa.actionSet.entityMetaId === action.actionSet.entityMetaId)
        }

        return sameAnalysisOrActionName
      })
      .map(fa => fa.actionSet.id)
  }

  return {
    updateActionIds,
  }
}

export default useImportActions
